import { render, staticRenderFns } from "./insurance-convert.vue?vue&type=template&id=0b6a2c7c&"
import script from "./insurance-convert.vue?vue&type=script&lang=js&"
export * from "./insurance-convert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports